import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YangiKiaAvtomobillariniBizBilanTanlang from "./sections/YangiKiaAvtomobillariniBizBilanTanlang";
import MySuperLetter from "./sections/MySuperLetter";
import CraftedFloridaAdventures from "./sections/CraftedFloridaAdventures";
import CorePillarsOfTheMind from "./sections/CorePillarsOfTheMind";
import ContactMessage from "./sections/ContactMessage";
import WhatOurGuestsSay from "./sections/WhatOurGuestsSay";
import HeritageHospitality from "./sections/HeritageHospitality";
import StoriesFromTheRoad from "./sections/StoriesFromTheRoad";
import Chooseyourjourney from "./sections/Chooseyourjourney";
import PieDePaginaHighClass from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YangiKiaAvtomobillariniBizBilanTanlang />
      <Chooseyourjourney />
      <MySuperLetter />
      <CraftedFloridaAdventures />
      <CorePillarsOfTheMind />
      <ContactMessage />
      <WhatOurGuestsSay />
      <HeritageHospitality />
      <StoriesFromTheRoad />
      <PieDePaginaHighClass />
    </div>;
}